module.exports = __webpack_public_path__ + "static/media/report5.4ed42522.png";